/** Query key for a thread's file list. */
export function SCOPE_FILES_QUERY_KEY(threadId: string) {
  return ["fileApi", "scopeFiles", threadId];
}
